// Configuración de Cloudinary para Domired

// Configuración de Cloudinary con los valores proporcionados por el usuario
const CLOUD_NAME = 'domiredxd'; // Nombre de nube en Cloudinary
const UPLOAD_PRESET = 'domird'; // Preset de carga sin firma configurado en Cloudinary

/**
 * Sube un archivo a Cloudinary y devuelve la URL segura
 * @param file Archivo a subir (imagen o video)
 * @returns URL segura del archivo subido
 */
export const uploadToCloudinary = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    // Validar el archivo antes de intentar subirlo
    if (!file || file.size === 0) {
      console.error('Error: Archivo inválido o vacío');
      reject(new Error('Archivo inválido o vacío'));
      return;
    }

    // Crear FormData
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    
    // Determinar el tipo de recurso (imagen o video)
    const resourceType = file.type.startsWith('video/') ? 'video' : 'image';
    
    // Mostrar información de depuración solo en desarrollo
    if (process.env.NODE_ENV !== 'production') {
      console.log('Iniciando carga a Cloudinary:', {
        fileName: file.name,
        fileType: file.type,
        resourceType,
        fileSize: `${(file.size / 1024).toFixed(2)} KB`,
        cloudName: CLOUD_NAME,
        uploadPreset: UPLOAD_PRESET
      });
    }
    
    // No agregamos transformaciones para mantener la configuración original
    
    // URL de la API de Cloudinary según el tipo de recurso
    const apiUrl = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${resourceType}/upload`;
    
    // Realizar la petición a Cloudinary
    fetch(apiUrl, {
      method: 'POST',
      body: formData,
    })
      .then(async response => {
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Error en la respuesta de Cloudinary:', response.status, response.statusText, errorText);
          
          // Analizar el error para dar mensajes más útiles
          if (errorText.includes('Invalid upload preset')) {
            throw new Error('Error de configuración: El preset de carga no es válido o no existe');
          } else if (errorText.includes('Resource not found')) {
            throw new Error('Error de configuración: El nombre de la nube de Cloudinary es incorrecto');
          } else if (response.status === 413) {
            throw new Error('El archivo es demasiado grande. El límite es de 10MB para cuentas gratuitas.');
          } else {
            throw new Error(`Error al subir a Cloudinary: ${response.status} ${response.statusText}`);
          }
        }
        return response.json();
      })
      .then(data => {
        if (data.secure_url) {
          console.log('Archivo subido exitosamente a:', data.secure_url);
          resolve(data.secure_url);
        } else if (data.error) {
          console.error('Error de Cloudinary:', data.error.message);
          reject(new Error(data.error.message));
        } else {
          console.error('Respuesta inesperada de Cloudinary:', data);
          reject(new Error('Error al subir a Cloudinary: Respuesta inesperada'));
        }
      })
      .catch(error => {
        console.error('Error al subir archivo a Cloudinary:', error);
        reject(new Error('Error al subir el archivo. Verifica tu configuración de Cloudinary e inténtalo de nuevo.'));
      });
  });
};
